export const pairs = [
  "XAU/USD",
  "US100",
  "US30",
  "EUR/USD",
  "GBP/USD",
  "USD/CHF",
  "AUD/USD",
  "NZD/USD",
  "USD/CAD",
  "JPY Pairs",
];
